import { IconButton } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Checkbox from "@material-ui/core/Checkbox"
import Container from "@material-ui/core/Container"
import CssBaseline from "@material-ui/core/CssBaseline"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import InputAdornment from "@material-ui/core/InputAdornment"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import Snackbar from "@material-ui/core/Snackbar"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { ArrowForwardIos } from "@material-ui/icons"
import CancelIcon from "@material-ui/icons/Cancel"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import { default as AlertFixo, default as MuiAlert } from "@material-ui/lab/Alert"
import { useSnackbar } from "notistack"
import { useEffect, useRef, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import Package from "../../../package.json"
import useParametros from "../../contexts/ParametrosContext"
import { RecebedorContextProvider } from "../../contexts/RecebedorContext"
import api from "../../services/api"
import { RegistrarLogErro } from "../../services/clientefiel"
import { AlertasPainel } from "../../services/fornecedor"
import {
    atualizarStatus,
    atualizarTempoEntrega,
    buscarestabelecimentos,
    buscarRedeDeEstabelecimentos,
    controleAcessoAtualizar,
    controleAcessoVerificar,
    ObterStatusLojaIfood,
    ResumoDia,
} from "../../services/integracao"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"
import Cabecalho from "../Cabecalho"
import Loading from "../Componentes/Loading"
import BotoesUtilitarios from "./components/BotoesUtilitarios"
import DialogCancelamento from "./components/DialogCancelamento"
import DialogInformacoesPedido from "./components/DialogInformacoesPedido"
import FiltroEntregaRetirada from "./components/FiltroEntregaRetirada"
import Transition from "./components/Transition"
import DialogAlertas from "./DialogAlertas"
import ListaIntegracoes from "./Integracoes/ListaIntegracoes"
import Print from "./print"
import { imprimirNotaFiscal } from "./qzConfig"
import "./styles.css"
import Lista from "./tabelas/Lista"
const qz = require("qz-tray")

const useStyles = makeStyles(theme => ({
    fixedRegistrador: {
        position: "fixed",
        left: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedStatus: {
        position: "fixed",
        left: "2em",
        bottom: "7em",
        zIndex: 1000,
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    adicionarImpressora: { height: "100%", width: "100%", padding: "15px 14px" },
    impressaoComandaCompleta: {
        width: "100%",
        margin: "0",
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
        "& > *": { flex: 1 },
    },
}))

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

function getImpressoras(configuracoes) {
    if (configuracoes.printer.impressoras?.length) return configuracoes.printer.impressoras

    return []
}

const LIMITE_NUMERO_IMPRESSORAS = 10

function ListaImpressorasSelecionadas({ mobile, tipoPainelImpressao, impressorasQZ }) {
    const classes = useStyles()
    const tabStatus = useAppStore(s => s.tabStatus)

    const configuracoes = useAppStore(s => s.configuracoes)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const [listaImpressoras, setListaImpressoras] = useState(getImpressoras(configuracoes))

    const handleChangeImpressora = (e, i) => {
        listaImpressoras[i] = e.target.value

        const impressorasFiltradas = listaImpressoras.filter(
            i => i && impressorasQZ.find(nomeImpressora => nomeImpressora === i)
        )

        setListaImpressoras(impressorasFiltradas)

        atualizarConfiguracoes({ printer: { impressoras: impressorasFiltradas } })
    }

    const handleChangeImpressaoIfood = e =>
        atualizarConfiguracoes({ printer: { imprimirComandasIfood: e.target.checked } })

    if (tipoPainelImpressao !== "plugin" || mobile || tabStatus !== "CRUD") return null

    const adicionarImpressora = () => setListaImpressoras(prev => [...prev, "Nenhuma"])

    const integradoComIfood = configuracoes.user?.parametros?.ativaIntegracaoIfood

    return (
        <>
            {listaImpressoras?.map((impressora, i) => (
                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel id="impressoras">{`Imprimir ${i + 1}º Opção`}</InputLabel>
                        <Select
                            fullWidth
                            value={impressora}
                            onChange={e => handleChangeImpressora(e, i)}
                            label={`Imprimir ${i + 1}º Opção`}
                        >
                            <MenuItem value="Nenhuma">Nenhuma</MenuItem>
                            {impressorasQZ.map((printer, index) => (
                                <MenuItem key={index} value={printer}>
                                    {printer}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Col>
            ))}
            {listaImpressoras.length < LIMITE_NUMERO_IMPRESSORAS ? (
                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                    <Button
                        variant="outlined"
                        onClick={adicionarImpressora}
                        className={classes.adicionarImpressora}
                    >
                        Adicionar Impressora
                    </Button>
                </Col>
            ) : null}
            {configuracoes?.user?.parametros?.impressaoAlternada ? (
                <>
                    <Row className={classes.impressaoComandaCompleta}>
                        <Col xs={12} md={6} lg={6} style={{ margin: "0" }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={configuracoes.printer.imprimirComandaCompleta}
                                        onChange={e =>
                                            atualizarConfiguracoes({
                                                printer: {
                                                    imprimirComandaCompleta: e.target.checked,
                                                },
                                            })
                                        }
                                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                                    />
                                }
                                label="Imprimir comanda completa"
                            />
                        </Col>
                        {configuracoes.printer.imprimirComandaCompleta ? (
                            <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                <FormControl variant="outlined" style={{ width: "100%" }}>
                                    <InputLabel id="impressoras">
                                        Impr. p/ comanda completa
                                    </InputLabel>
                                    <Select
                                        fullWidth
                                        value={configuracoes.printer.impressoraComandaCompleta}
                                        onChange={e =>
                                            atualizarConfiguracoes({
                                                printer: {
                                                    impressoraComandaCompleta:
                                                        e.target.value !== "Nenhuma"
                                                            ? e.target.value
                                                            : null,
                                                },
                                            })
                                        }
                                        label="Impr. p/ comanda completa"
                                    >
                                        <MenuItem value="Nenhuma">Nenhuma</MenuItem>
                                        {impressorasQZ.map((printer, index) => (
                                            <MenuItem key={index} value={printer}>
                                                {printer}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Col>
                        ) : null}
                    </Row>
                </>
            ) : null}
            {integradoComIfood ? (
                <Col xs={12} md={6} lg={6} style={{ margin: "0" }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={configuracoes.printer.imprimirComandasIfood ?? true}
                                onChange={handleChangeImpressaoIfood}
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                            />
                        }
                        label="Imprimir comandas do iFood"
                    />
                </Col>
            ) : null}
        </>
    )
}

const formatter = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })

const listaCancelamento99food = [
    { cod: "1010", description: "Item esgotado" },
    { cod: "1020", description: "Loja fechada" },
    { cod: "1030", description: "A loja está muito ocupada para preparar a refeição" },
    {
        cod: "1040",
        description: "Impossível preparar a refeição devido a falhas de água ou energia",
    },
    { cod: "1050", description: "Cancelamento por solicitação do cliente" },
    { cod: "1060", description: "Sem entregador disponível." },
    { cod: "1080", description: "Outro motivo" },
]

const TEMPO_MINIMO_ALLDAY = 30

export default function RecebedorDePedidos() {
    const theme = useTheme()
    const history = useHistory()
    const classes = useStyles()
    const params = useParametros()

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
    const autorizacao = localStorage.getItem("chaveSistema")

    const buscarPedidos = useAppStore(s => s.buscarPedidos)
    const configuracoes = useAppStore(s => s.configuracoes)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const [valorEntregasFuiApp, setValorEntregasFuiApp] = useState(false)
    const [modalChamarEntregadorFui, setModalChamarEntregadorFui] = useState(false)
    const [formaPagamentoSelecionadaFui, setFormaPagamentoSelecionadaFui] = useState({})

    const [openConfirmacaoPedidosRepetidosFui, setOpenConfirmacaoPedidosRepetidosFui] =
        useState(false)
    const [
        messageOpenConfirmacaoPedidosRepetidosFui,
        setMessageOpenConfirmacaoPedidosRepetidosFui,
    ] = useState("")
    const [pedidosEntregaFuiApp, setPedidosEntregaFuiApp] = useState([])
    const [statusLojaIfood, setStatusLojaIfood] = useState({})
    const [statusLoja99, setStatusLoja99] = useState({})
    const [filaPrints, setFilaPrints] = useState([])
    const [contratar, setContratar] = useState(false)
    const [registradorModal, setRegistradorModal] = useState(false)

    const tabStatus = useAppStore(s => s.tabStatus)
    const setTabStatus = useAppStore(s => s.setTabStatus)

    useEffect(() => {
        localStorage.setItem("tabStatus", tabStatus)
    }, [tabStatus])

    useEffect(() => {
        if (mobile) setTabStatus("VIEW")
    }, [])

    const impressorasQZ = useAppStore(s => s.impressorasQZ)

    const [modalEntregadorFuiDelivery, setModalEntregadorFuiDelivery] = useState({
        openModal: false,
    })
    const busqueiTodosPedidos = useRef(true)
    const [modalInformacoesPedido, setModalInformacoesPedido] = useState({})
    const [arrayTodosPedidos, setArrayTodosPedidos] = useState([])
    const [arraySegundo, setArraySegundo] = useState([])
    const [confirmarCancelamento, setConfirmarCancelamento] = useState(null)

    const [pedidosAguardandoAceitacao, setPedidosAguardandoAceitacao] = useState([])
    const [pedidosAceitos, setPedidosAceitos] = useState([])
    const [pedidosEmPreparacao, setPedidosEmPreparacao] = useState([])
    const [pedidosEmEntrega, setPedidosEmEntrega] = useState([])
    const [pedidosFinalizados, setPedidosFinalizados] = useState([])

    const [loadingPedidos, setLoadingPedidos] = useState(true)

    const [expandListaIntegracoes, setExpandListaIntegracoes] = useState(false)

    const { user, printer, recebedor } = configuracoes

    const imprimirPedidoMesa = recebedor.imprimirPedidoMesa ?? true

    const tamanhoLista = recebedor.prepararPedidoAutomatico ? 4 : 3
    console.log("-> Recebedor Configuração ", recebedor)

    const tipoPainelImpressao =
        impressorasQZ.length > 0
            ? "plugin" //qz
            : window.navigator.userAgent.includes("Electron")
            ? "software" //exe
            : "navegador" //padrao do navegador

    const { parametros } = user

    const [modalIfoodConfig, setModalIfoodConfig] = useState(false)
    const [modalConfiguracoes, setModalConfiguracoes] = useState(false)
    const setLoading = useLoadingStore(s => s.setLoading)
    const [alert, setAlert] = useState({ status: false, tipo: "success", mesangem: "" })

    const [estabelecimentos, setEstabelecimentos] = useState([])
    const [openEstabelecimentos, setOpenEstabelecimentos] = useState(false)

    const mandarImprimir = useAppStore(s => s.mandarImprimir)
    const buscarImpressoras = useAppStore(s => s.buscarImpressoras)

    const workerRef = useRef(null)

    const listaMotivoCancelamento =
        confirmarCancelamento?.plataforma === "didi_food"
            ? listaCancelamento99food
            : parametros.listaMotivoCancelamento

    const tipoPrinter =
        tipoPainelImpressao === "plugin"
            ? printer.tipoImpressao
                ? printer.tipoImpressao
                : "code"
            : ""
    const tamanhoFonteSelect = printer.tamanhoFonteSelect ? printer.tamanhoFonteSelect : "media"

    const exibirTamanhoFonte = tipoPrinter === "html"
    const exibirImprimirLogo = tipoPrinter === "code"
    const exibirSeletorTamanho = tipoPrinter === "code"
    const exibir99food = tipoPrinter === "code" || tipoPrinter === "html"

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const alertClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setAlert({ status: false, tipo: alert.tipo, mesangem: alert.mesangem })
    }

    const todosPedidos = () => {
        return pedidosAceitos
            .concat(pedidosEmPreparacao)
            .concat(pedidosEmEntrega)
            .concat(pedidosFinalizados)
    }

    const changeCheckFuiApp = (isChecked, identificador) => {
        const pedidos = JSON.parse(JSON.stringify(pedidosEntregaFuiApp))

        if (isChecked) {
            pedidos.push(identificador)
            setPedidosEntregaFuiApp(pedidos)
        } else {
            const index = pedidos.indexOf(identificador)
            pedidos.splice(index) //remove
            setPedidosEntregaFuiApp(pedidos)
        }
    }
    const checkPedidoAgrupaFuiAppDelivery = (pedidoEscolhido, identificador, bairro) => {
        var isSameIdCheck = pedidoEscolhido?.id === identificador

        if (isSameIdCheck && pedidosEntregaFuiApp?.indexOf(identificador) === -1) {
            changeCheckFuiApp(isSameIdCheck, identificador)
        }

        var show = pedidosEntregaFuiApp?.indexOf(identificador) !== -1 || isSameIdCheck

        return (
            <FormControlLabel
                control={
                    <Checkbox
                        checked={show}
                        onChange={e => {
                            var checked = e.target.checked
                            const pedidos = JSON.parse(JSON.stringify(pedidosEntregaFuiApp))

                            if (checked) {
                                pedidos.push(identificador)
                                setPedidosEntregaFuiApp(pedidos)
                            } else {
                                const index = pedidos.indexOf(identificador)
                                pedidos.splice(index) //remove
                                setPedidosEntregaFuiApp(pedidos)
                            }
                        }}
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        name={identificador.toString()}
                        id={identificador.toString()}
                    />
                }
                label={"#" + identificador + " (" + bairro + ")"}
            />
        )
    }

    const showCheckbox = pedidoEscolhido => {
        var rows = []
        var qnt = arraySegundo.length
        for (var i = 0; i < qnt; i++) {
            const lista = arraySegundo
            const item = lista[i]
            var bairro = "--"
            if (item?.deliveryAddress?.neighborhood) {
                bairro = item?.deliveryAddress?.neighborhood
            }
            rows.push(checkPedidoAgrupaFuiAppDelivery(pedidoEscolhido, item.id, bairro))
        }
        return <Container>{rows}</Container>
    }

    const validarPedidosJaEnviadosFuiDelivery = async () => {
        try {
            const body = {
                pedidosId: pedidosEntregaFuiApp,
            }

            setLoading(true)
            await api
                .post(`entrega/fuiAppDelivery/validarPedidosJaEnviados/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    setLoading(false)
                    if (response.status === 200) {
                        calcularValorEntregaFuiApp()
                    } else {
                        console.log("Resposta Validação", response)
                        alertStart("Erro ao validar pedido", "error")
                    }
                })
                .catch(error => {
                    setLoading(false)
                    let response = error.response.data
                    setOpenConfirmacaoPedidosRepetidosFui(true)
                    setMessageOpenConfirmacaoPedidosRepetidosFui(response.message)
                })
        } catch (error) {
            setLoading(false)
            console.log(error)
            RegistrarLogErro(error, "validarPedidosJaEnviados", pedidosEntregaFuiApp)
        }
    }

    const calcularValorEntregaFuiApp = async () => {
        try {
            const body = {
                pedidosId: pedidosEntregaFuiApp,
            }

            setLoading(true)
            await api
                .post(`entrega/fuiAppDelivery/consultarValor/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    if (typeof response.data === "string") {
                        console.log(response.data)
                        alertStart("Erro ao consultar valores", "error")
                    } else {
                        const retorno = response.data
                        setValorEntregasFuiApp(retorno)
                        setModalChamarEntregadorFui(true)
                    }
                    setLoading(false)
                })
        } catch (error) {
            let response = error.response.data
            alertStart(response.message, "error")
            setLoading(false)
            RegistrarLogErro(error, "consultarValorEntrega", pedidosEntregaFuiApp)
        }
    }

    const chamarEntregadorFui = async (entregaObj, servicoId, formaPagamentoId) => {
        setLoading(true)

        try {
            const body = {
                calculoResponse: entregaObj.calculoResponse,
                entregaParam: entregaObj.entregaParam,
                calculaParam: entregaObj.calculaParam,
                servicoFuiApp: servicoId,
                tipoPagamentoFuiApp: formaPagamentoId,
            }

            await api
                .post(`entrega/fuiAppDelivery/solicitarEntrega/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    console.log("Testeeeee ----", console.log(JSON.stringify(response)))
                    if (typeof response.data === "string") {
                        alertStart("Não foi possivel solicitar a entrega", "error")
                        console.log("Retorno Solicitacação Criada Type Error: ", response.data)
                    } else {
                        const retorno = response.data
                        alertStart(retorno.message, "success")
                        // setValorEntregasFuiApp(retorno)
                        // setModalChamarEntregadorFui(true);

                        console.log("Respostaaa Solicitacao", response.data)
                    }
                    setLoading(false)
                })
                .catch(error => {
                    let response = error.response.data
                    alertStart(response.message, "error")
                })
            setLoading(false)
        } catch (error) {
            setLoading(false)
            alertStart(error, "error")
            RegistrarLogErro(error, "solicitarEntrega", { entregaObj, servicoId, formaPagamentoId })
        }
    }

    const showDialogConfirmarValoresFui = () => {
        return (
            <Dialog
                fullScreen={fullScreen}
                open={modalChamarEntregadorFui}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => {
                    setFormaPagamentoSelecionadaFui(null)
                    setModalChamarEntregadorFui(false)
                }}
            >
                <DialogTitle>{"Confirmar Dados Entrega"}</DialogTitle>
                <DialogContent>
                    {valorEntregasFuiApp?.calculoResponse?.enderecoOrigem ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                <h4>Origem</h4>
                            </Typography>
                            <Typography>
                                {" * " + valorEntregasFuiApp?.calculoResponse?.enderecoOrigem}
                            </Typography>
                        </Col>
                    ) : null}

                    {valorEntregasFuiApp?.calculoResponse?.destinos ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                <h4>Destino(s)</h4>
                            </Typography>
                        </Col>
                    ) : null}

                    {valorEntregasFuiApp?.calculoResponse?.destinos?.map((destino, index) => (
                        <Col key={index} xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>{" * " + destino.endereco}</Typography>
                        </Col>
                    ))}

                    {!valorEntregasFuiApp?.calculoResponse?.servicos ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                Infelizmente não encontramos serviços referente à sua solicitação
                            </Typography>
                        </Col>
                    ) : null}

                    <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "60%" }}
                        >
                            <InputLabel id="pagamentofuiapp">Pagamento</InputLabel>
                            <Select
                                fullWidth
                                onChange={e => {
                                    setFormaPagamentoSelecionadaFui({
                                        name: e.target.name,
                                        id: e.target.value,
                                    })
                                }}
                                label="Forma de Pagamento"
                            >
                                {valorEntregasFuiApp?.formasPagamentoDisponiveis?.map(
                                    (formaPagamentoFui, index) => (
                                        <MenuItem
                                            name={formaPagamentoFui?.tipoPagamentoDesc}
                                            value={formaPagamentoFui?.tipoPagamentoID}
                                            key={formaPagamentoFui?.tipoPagamentoID}
                                        >
                                            <em>{formaPagamentoFui?.tipoPagamentoDesc}</em>
                                        </MenuItem>
                                    )
                                )}
                            </Select>
                        </FormControl>
                    </Col>

                    {valorEntregasFuiApp?.calculoResponse?.servicos?.map((servico, index) => (
                        <Col key={index} xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>{"-------------------------"}</Typography>
                            <Typography>
                                {servico.servicoNome}
                                {" -- "}
                                {Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                }).format(servico.valor)}
                                <Button
                                    onClick={() => {
                                        if (!formaPagamentoSelecionadaFui?.id) {
                                            alertStart("Escolha a forma de pagamento", "error")
                                            return
                                        }
                                        chamarEntregadorFui(
                                            valorEntregasFuiApp,
                                            servico,
                                            formaPagamentoSelecionadaFui.id
                                        )
                                        setModalChamarEntregadorFui(false)
                                    }}
                                >
                                    Solicitar
                                </Button>
                            </Typography>
                        </Col>
                    ))}
                    <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                        {"-------------------------"}
                    </Col>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setFormaPagamentoSelecionadaFui(null)
                            setModalChamarEntregadorFui(false)
                        }}
                    >
                        Voltar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const desenvolvimento =
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("192.168")

    const [abrirAlertas, setAbrirAlertas] = useState(false)
    const [alertas, setAlertas] = useState([])
    const getAlertasSistema = async () => {
        try {
            const response = await AlertasPainel(configuracoes.user?.parametros?.appNome)

            setAlertas(response.map(alerta => alerta.replaceAll("\n", "").replaceAll("\r", "")))

            if (!desenvolvimento) {
                setAbrirAlertas(response.length > 0)
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        const efeitoAtivo = window.getCookie("efeito-sonoro-ativo")
            ? window.getCookie("efeito-sonoro-ativo") === "true"
            : true

        document.querySelector("#audiopedido")?.load()

        const imprimir99 = window.getCookie("imprimir-99")
            ? window.getCookie("imprimir-99") === "true"
            : true

        if (efeitoAtivo !== printer.efeitoSonoro) {
            atualizarConfiguracoes({ recebedor: { efeitoSonoro: efeitoAtivo } })
            window.setCookie("efeito-sonoro-ativo", efeitoAtivo, 9999)
        }

        if (imprimir99 !== printer.imprimir99automatico) {
            atualizarConfiguracoes({ printer: { imprimir99automatico: imprimir99 } })
            window.setCookie("imprimir-99", imprimir99, 9999)
        }

        getAlertasSistema()
    }, [])

    useEffect(() => {
        try {
            buscarTodosPedidos(localStorage.getItem("chaveSistema"))
            verificarSeTemQZ()
        } catch (error) {
            RegistrarLogErro(error, "userEffect1")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabStatus])

    useEffect(() => {
        try {
            if (parametros?.estabelecimento?.id && tabStatus === "CRUD") {
                if (window.name === "") {
                    window.name = `${parametros?.estabelecimento?.id}_${Math.random()}_${
                        Package.version
                    }`
                    atualizarTabNavegador(window.name)
                }
                const interval = setInterval(() => {
                    verificarTabNavegador(window.name)
                }, 5000)
                return () => clearInterval(interval)
            }
        } catch (error) {
            RegistrarLogErro(error, "userEffect2")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabStatus, configuracoes])

    useEffect(() => {
        try {
            const rootPrint = document.getElementById("rootPrint")

            switch (configuracoes.printer.tamanhoFonteNavegador) {
                case "normal":
                    rootPrint.classList.remove("textoImpressaoGrande")
                    break

                case "grande":
                    rootPrint.classList.add("textoImpressaoGrande")
                    break
            }

            if (tabStatus === "CRUD") {
                const interval = setInterval(() => {
                    verificarSeTemQZ()
                }, 20000)
                return () => clearInterval(interval)
            }
        } catch (error) {
            RegistrarLogErro(error, "userEffect3")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [impressorasQZ, configuracoes, tabStatus])

    const [estabelecimentosRede, setEstabelecimentosRede] = useState(null)

    useEffect(() => {
        const handleBuscarRedeDeEstabelecimentos = async () => {
            try {
                setLoading(true)
                const response = await buscarRedeDeEstabelecimentos(autorizacao)
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                    setLoading(false)
                    return false
                }
                setEstabelecimentosRede(response)
                setLoading(false)
            } catch (error) {
                RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
            }
        }

        if (!estabelecimentosRede) {
            handleBuscarRedeDeEstabelecimentos()
        }
    }, [])

    const hasIfood = parametros?.ativaIntegracaoIfood

    useEffect(() => {
        console.log("has_integrationIfood", hasIfood)

        let intervalLojaIFood
        // let intervalLoja99

        if (tabStatus === "CRUD") {
            if (hasIfood) {
                try {
                    verificarStatusLojaIfood(autorizacao)
                    intervalLojaIFood = setInterval(function () {
                        verificarStatusLojaIfood(autorizacao)
                    }, 30000)
                } catch (error) {
                    console.log("Erro status Loja ifood", error)
                }
            }
        }

        return () => {
            clearInterval(intervalLojaIFood)
            // clearInterval(intervalLoja99)
        }
    }, [autorizacao, parametros])

    const buscarNovosEventos = useAppStore(s => s.buscarNovosEventos)

    useEffect(() => {
        if (workerRef.current) {
            workerRef.current.postMessage("stop")
            workerRef.current = null
        }

        if (tabStatus === "CRUD") {
            workerRef.current = new Worker(new URL("./worker.js", import.meta.url))
            workerRef.current.postMessage("start-timer")

            workerRef.current.onmessage = async e => {
                if (e.data === "fetch") {
                    await buscarNovosEventos(autorizacao)
                    workerRef.current.postMessage("start-timer")
                }
            }
        }

        return () => {
            if (workerRef.current) {
                workerRef.current.postMessage("stop")
                workerRef.current = null
            }
        }
    }, [])

    useEffect(() => {
        if (pedidosEmPreparacao.length && recebedor.prepararPedidoAutomatico) {
            const maiorId = pedidosEmPreparacao.reduce(
                (maiorId, pedido) => Math.max(pedido.id, maiorId),
                0
            )
            window.setTimeout(() => {
                if (maiorId > localStorage.getItem("ultimo-aviso-sonoro")) {
                    localStorage.setItem("ultimo-aviso-sonoro", maiorId)
                    ativarAviso()
                }
            }, 1000)
        }
    }, [pedidosEmPreparacao])

    const atualizar = (loading = false) => {
        try {
            if (loading) {
                setLoadingPedidos(true)
            }
            //faz pull indiana
            if (parametros?.ativarIndiana) {
                var objPullIndiana = {
                    codigoFilial: parametros?.codigoFilialIndiana,
                    codigoEmpresa: parametros?.codigoEmpresaEntregaIndiana,
                }
                buscaPedidosIntegracaoIndiana(autorizacao, objPullIndiana)
            } else {
                buscarTodosPedidos(autorizacao)
            }
        } catch (error) {
            RegistrarLogErro(error, "atualizar")
        }
    }

    async function atualizarTempoEntregaEstabelecimento(tempo, estabelecimento, index) {
        try {
            estabelecimento.tempoEntregaTexto = tempo
            const response = await atualizarTempoEntrega(autorizacao, estabelecimento)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const novoEstabelecimentos = Object.assign([], estabelecimentos)
            novoEstabelecimentos[index].tempoEntregaTexto = response.tempoEntregaTexto
            setEstabelecimentos(novoEstabelecimentos)
        } catch (error) {}
    }
    async function atualizarStatusEstabelecimento(e, estabelecimento, index) {
        try {
            const data = {
                idEstabelecimento: estabelecimento.id,
                situacao: e.target.value,
            }
            const response = await atualizarStatus(autorizacao, data)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const novoEstabelecimentos = Object.assign([], estabelecimentos)
            novoEstabelecimentos[index].situacao = response.situacao
            novoEstabelecimentos[index].pausado = response.pausado
            setEstabelecimentos(novoEstabelecimentos)
        } catch (error) {}
    }

    const solicitarEntregaFuiDelivery = async (Authorization, pedido) => {
        setModalEntregadorFuiDelivery({
            ...modalEntregadorFuiDelivery,
            openModal: true,
            pedidoSelecionado: pedido,
        })
    }

    const handleBuscarDadosEstabelecimentos = async modificar => {
        try {
            setLoading(true)
            const response = await buscarestabelecimentos(autorizacao)
            console.log("Parametros", response)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setEstabelecimentos(response)
            if (modificar) setOpenEstabelecimentos(true)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
        }
        return {}
    }

    useEffect(() => {
        // TODO: Checar impressão por navegador
        const pausarImpressao = async ms => new Promise(res => setTimeout(res, ms))

        const imprimirLista = async () => {
            const idUltimoPedido = localStorage.getItem("ultimoImprimir")
            const copiaPedidosAceitos = [
                ...(recebedor.prepararPedidoAutomatico ? pedidosEmPreparacao : pedidosAceitos),
            ].sort((a, b) => a.id - b.id)

            // TODO: Otimizar para sair do loop
            for (let i = 0; i < copiaPedidosAceitos.length; i++) {
                const pedido = copiaPedidosAceitos[i]
                if (pedido.id > idUltimoPedido) {
                    localStorage.setItem("ultimoImprimir", pedido.id)

                    if (
                        configuracoes.printer.imprimirComandasIfood === false &&
                        pedido.plataforma === "ifood_integracao"
                    )
                        continue

                    await pausarImpressao(2500)
                    mandarImprimir({
                        pedido: pedido,
                        texto: pedido.texto,
                    })
                }
            }
        }

        if (
            (recebedor.prepararPedidoAutomatico ? pedidosEmPreparacao : pedidosAceitos).length >
                0 &&
            recebedor.aceitarPedidoAutomatico &&
            recebedor.imprimirPedidoAutomatico &&
            tipoPainelImpressao === "navegador"
        ) {
            imprimirLista()
        }
    }, [recebedor.prepararPedidoAutomatico ? pedidosEmPreparacao : pedidosAceitos])

    useEffect(() => {
        const array = recebedor.aceitarPedidoAutomatico
            ? pedidosAceitos
            : pedidosAguardandoAceitacao

        if (!array.length) {
            desativarAviso()
        }

        // TODO: Checar se é necessário
        // pedidosAguardandoAceitacao.forEach(pedido => {
        //     const index = pedidosAceitos.findIndex(p => p.id === pedido.id)
        //     if (index !== -1)
        //         setPedidosAguardandoAceitacao(prev => {
        //             const retorno = JSON.parse(JSON.stringify(prev))

        //             retorno.splice(index, 1)

        //             return retorno
        //         })
        // })
    }, [pedidosAguardandoAceitacao, pedidosAceitos])

    const statusPedido = status => {
        switch (status) {
            case 0:
                return "Aguardando aceitação"

            case 1:
            case 2:
                return "Aceito"

            case 3:
            case 6:
                return "Em entrega"

            case 4:
            case -1:
            case -2:
            case -3:
            case -4:
            case -10:
                return "Finalizado"

            default:
                return "Em preparação"

            // if (status === 0 && recebedor.aceitarPedidoAutomatico) {
            //     return "ACEITARAUTOMATICO"
            // } else if (
            //     status === 0 ||
            //     (recebedor.aceitarPedidoAutomatico && (status === 1 || status === 2))
            // ) {
            //     return "PRIMEIRO"
            // } else if (status === 3 || status === 6) {
            //     return "TERCEIRO"
            // } else if (
            //     status === 4 ||
            //     status === -1 ||
            //     status === -2 ||
            //     status === -3 ||
            //     status === -4 ||
            //     status === -10
            // ) {
            //     return "QUARTO"
            // } else {
            //     return "SEGUNDO"
            // }
        }
    }

    const updatePedidosRecebidos = useAppStore(s => s.updatePedidosRecebidos)

    const buscaPedidosIntegracaoIndiana = async (Authorization, body) => {
        console.log("Buscando all Pedidos (INDIANA)", body)
        try {
            await api
                .post(`indiana/pull/all`, body, {
                    headers: { "Content-Type": "application/json", Authorization: Authorization },
                })
                .then(async response => {
                    console.log("response", response)
                    updatePedidosRecebidos(response)
                })
            setLoadingPedidos(false)
        } catch (error) {
            RegistrarLogErro(error, "buscaPedidosIntegracaoIndiana", body)
            alertStart("Erro ao buscar todos os Buscar Pedidos da Indiana!", "error")
            return false
        }
    }

    const buscarTodosPedidos = async Authorization => {
        console.log("Buscando all Pedidos", Authorization)
        try {
            setLoading(true)
            await api
                .get(`integracao/orders/allday`, {
                    headers: { "Content-Type": "application/json", Authorization: Authorization },
                })
                .then(async response => {
                    updatePedidosRecebidos(response)
                })
            setLoadingPedidos(false)
        } catch (error) {
            RegistrarLogErro(error, "buscarTodosPedidos")
            alertStart("Erro ao buscar todos os pedidos!", "error")
            return false
        } finally {
            setLoading(false)
        }
    }

    const atualizarTabNavegador = async name => {
        try {
            const response = await controleAcessoAtualizar(parametros?.estabelecimento?.id, name)

            if (response.retornoErro) {
                //algum erro
                console.error(
                    "controleAcessoAtualizar>> \n\n\n controleAcessoAtualizar>> ",
                    response
                )
            } else {
                //tudo certo
                console.log("controleAcessoAtualizar>> \n\n\n controleAcessoAtualizar>> ", response)
            }
        } catch (error) {
            RegistrarLogErro(error, "atualizarTabNavegador", name)
        }
    }

    const verificarTabNavegador = async name => {
        try {
            const response = await controleAcessoVerificar(
                parametros?.estabelecimento?.id,
                name.replace("/", "-")
            )

            if (response.retornoErro) {
                //algum erro
                console.error(
                    "controleAcessoVerificar>> \n\n\n controleAcessoVerificar>> ",
                    response
                )
            } else {
                //tudo certo
                // console.log("controleAcessoVerificar>> \n\n\n controleAcessoVerificar>> ", response)
                if (response.exist === false) {
                    document.getElementById("aviso-dois-recebedores").style.display = "block"
                } else {
                    document.getElementById("aviso-dois-recebedores").style.display = "none"
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarTabNavegador", name)
        }
    }

    const verificarSeTemQZ = () => {
        try {
            //console.log('|||||||||||| verificar se tem qz')
            if (qz.websocket.isActive()) {
                buscarImpressoras()
            } else {
                qz.websocket
                    .connect()
                    .then(() => {
                        qz.printers
                            .details()
                            .then(function (data) {
                                for (var i = 0; i < data.length; i++) {
                                    console.log(
                                        data[i].name +
                                            " " +
                                            data[i].driver +
                                            " " +
                                            data[i].density +
                                            " " +
                                            data[i].trays
                                    )
                                }
                            })
                            .catch(function (e) {
                                console.error(e)
                            })

                        //console.log('Conectado QZ!');
                        buscarImpressoras()
                    })
                    .catch(err => {
                        console.error("Erro QZ", err.message)
                        // alertStart("Impressao automatica não identifica!", "error")
                        if (tipoPainelImpressao === "plugin") {
                            // TODO:
                            // setImpressorasQZ([])
                        }
                    })
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarSeTemQZ")
        }
    }

    const verificarStatusLojaIfood = async Authorization => {
        const retorno = await ObterStatusLojaIfood(parametros?.estabelecimento, Authorization)

        if (retorno.retornoErro) {
            setStatusLojaIfood({
                title: "...",
                message: "...",
            })
            return false
        }

        setStatusLojaIfood({
            title: retorno?.available ? "Loja Aberta" : "Loja Fechada",
            message: retorno?.message,
            extraInfo: retorno?.extraInfo,
        })
    }

    const buscarInformacoesPedido = async (Authorization, pedido) => {
        //console.log('buscarInformacoesPedido', pedido)
        var retorno = {}
        try {
            await api
                .get(`integracao/orders/${pedido.correlationId}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: Authorization,
                        //"fixed_token_ifood": hashInternaClienteFielIfood, //deprecated
                        // "ifood_integration_active": ativaIntegracaoIfood //deprecated
                    },
                })
                .then(response => {
                    //console.log("buscarInformacoesPedido", response.data)
                    response.data.evento = pedido
                    retorno = response.data
                })
        } catch (error) {
            RegistrarLogErro(error, "buscarInformacoesPedido", pedido)
        }
        return retorno
    }

    const buscarStatus = pedido => {
        /* 
      AGUARDANDO_ACEITACAO = 0;
      ACEITO = 1;
      CONFIRMACAO_VISUALIZADA = 2;
      EM_ENTREGA = 3;
      ENTREGUE = 4;
      PAGO = 5;
      PRONTO = 6;
      EM_PRODUCAO = 7;
      AGUARDANDO ATUALIZAR STATUS = 10;

      CANCELADO_PELO_DISTRIBUIDOR = -1;
      CANCELADO_PELO_CLIENTE = -2;
      NAO_ENTREGUE = -3;
      EXPIRADO = -4;
      CHARGEBACK = -10;
    */
        switch (pedido.status) {
            case 0:
                return "Aguardando Aceitação"
            case 1:
            case 2:
                return "Aceito"
            case 3:
                if (pedido.type === "1") return "Em Retirada"
                return "Em Entrega"
            case 4:
                return "Entregue"
            case 5:
                return "Pago"
            case 6:
                if (pedido.type === "2") return "Em Entrega"
                return "Em Retirada"
            case 7:
                return "Preparação"
            case -1:
                return "Loja Cancelou"
            case -2:
                return "Cliente Cancelou"
            case -3:
                return "Não Entregue"
            case -4:
                return "Expirado"
            case -10:
                return "ChargeBack"

            default:
                return "Não Identificado"
        }
    }

    const resumoDoDia = async () => {
        const res = await ResumoDia(autorizacao)

        // Necessário porque função de imprimir remove as duas primeiras quebras de linha
        let textos =
            "\n\n" +
            res.message
                .replaceAll(
                    "<hr/>",
                    `
-----------------------`
                )
                .replaceAll("<br/>", "\n")
                .replaceAll(/(-----)([^-])/g, "$1\n$2")

        mandarImprimir({
            texto: textos,
            qtd: 1,
            isResumo: true,
        })
    }

    // TODO: Mover para RecebedorContext
    const mudarStatusPara = async (status, autorizacao, pedido, index, imprimir = true) => {
        console.log("status, autorizacao, pedido, index", status, autorizacao, pedido, index)
        try {
            switch (status) {
                case -1:
                    setConfirmarCancelamento(pedido)
                    break
                case 1:
                    await aceitarPedido(pedido, imprimir)
                    break
                case 7:
                    await prepararPedido(pedido, imprimir)
                    break
                case 3:
                    await despacharPedido(pedido)
                    break
                case 6:
                    await retirarPedido(pedido)
                    break
                case 4:
                    await finalizarPedido(pedido)
                    break

                default:
                    break
            }
        } catch (error) {
            RegistrarLogErro(error, "mudarStatusPara", { status, pedido })
        }
    }

    const removerPedidoListaAnterior = pedido => {
        try {
            switch (statusPedido(pedido.status)) {
                case "Aguardando aceitação":
                    setPedidosAguardandoAceitacao(prev => prev.filter(p => p.id !== pedido.id))
                    break
                case "Aceito":
                    setPedidosAceitos(prev => prev.filter(p => p.id !== pedido.id))
                    break
                case "Em preparação":
                    setPedidosEmPreparacao(prev => prev.filter(p => p.id !== pedido.id))
                    break
                case "Em entrega":
                    setPedidosEmEntrega(prev => prev.filter(p => p.id !== pedido.id))
                    break
                case "Finalizado":
                    setPedidosFinalizados(prev => prev.filter(p => p.id !== pedido.id))
                    break
            }
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "removerPedidoListaAnterior", pedido)
        }
    }

    const ativarAviso = useAppStore(s => s.ativarAviso)
    const desativarAviso = useAppStore(s => s.desativarAviso)

    const aceitarPedido = useAppStore(s => s.aceitarPedido)
    const prepararPedido = useAppStore(s => s.prepararPedido)
    const despacharPedido = useAppStore(s => s.despacharPedido)
    const retirarPedido = useAppStore(s => s.retirarPedido)
    const finalizarPedido = useAppStore(s => s.finalizarPedido)

    const handleCloseEstabelecimentos = () => {
        const tempoEntregaElements = document.getElementsByClassName("tempoEntrega")
        for (let i = 0; i < tempoEntregaElements.length; i++) {
            const element = tempoEntregaElements[i].firstChild.firstChild

            if (element.value.length > 10) {
                alertStart("Tempo de entrega deve ter um máximo de 10 caracteres", "error")
                return
            }

            atualizarTempoEntregaEstabelecimento(
                element.value,
                estabelecimentos[element.dataset?.indexEstabelecimento],
                element.dataset?.indexEstabelecimento
            )
        }
        setOpenEstabelecimentos(false)
    }

    if (recebedor.exibirTempoEspera === undefined)
        atualizarConfiguracoes({ recebedor: { exibirTempoEspera: true } })

    const painelInstalado = sessionStorage.getItem("direcionamentoInicial")
    const [mesaModal, setMesaModal] = useState(false)
    const [filtroAgendado, setFiltroAgendado] = useState(0)

    return (
        <RecebedorContextProvider atualizar={atualizar}>
            <Dialog
                open={registradorModal}
                fullScreen={true}
                onClose={() => {
                    setRegistradorModal(false)
                }}
            >
                <DialogTitle>
                    <IconButton
                        className="setaVoltarModal"
                        onClick={() => {
                            setRegistradorModal(false)
                            buscarTodosPedidos(localStorage.getItem("chaveSistema"))
                        }}
                    >
                        <ArrowForwardIos />
                    </IconButton>
                    Registrador de Pedidos
                </DialogTitle>
                <DialogContent
                    style={{
                        padding: "0",
                    }}
                >
                    <iframe
                        style={{
                            height: "calc(100% - 0.4rem)",
                            width: "100%",
                        }}
                        src={"/servicos/modulo/registrador-de-pedidos?iframe=true"}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={mesaModal}
                fullScreen={true}
                onClose={() => {
                    setMesaModal(false)
                }}
            >
                <DialogTitle>
                    <IconButton
                        className="setaVoltarModal"
                        onClick={() => {
                            setMesaModal(false)
                            buscarTodosPedidos(localStorage.getItem("chaveSistema"))
                        }}
                    >
                        <ArrowForwardIos />
                    </IconButton>
                    Mesas
                </DialogTitle>
                <DialogContent
                    style={{
                        padding: "0",
                    }}
                >
                    <iframe
                        style={{
                            height: "calc(100% - 0.4rem)",
                            width: "100%",
                        }}
                        src={"/servicos/modulo/gerenciador-de-mesas"}
                    />
                </DialogContent>
            </Dialog>

            <Container
                component="main"
                maxWidth="lg"
                className="distanciaTop"
                style={{ minHeight: "120vh", paddingLeft: mobile ? "" : "80px" }}
            >
                <Cabecalho
                    pagina="Painel de Pedidos"
                    avisoDoisRecebedores
                    botaoModoVisualizacao={tabStatus !== "VIEW"}
                    alertas={alertas}
                    openAlertas={() => setAbrirAlertas(true)}
                />

                <Print filaPrints={filaPrints} setFilaPrints={setFilaPrints} />

                <Loading />

                <Snackbar open={alert.status} autoHideDuration={6000} onClose={alertClose}>
                    <Alert onClose={alertClose} severity={alert.tipo}>
                        {alert.mesangem}
                    </Alert>
                </Snackbar>

                <CssBaseline />

                <Dialog
                    open={contratar}
                    onClose={() => {
                        setContratar(false)
                    }}
                >
                    <DialogTitle>{"Contato para Contratar"}</DialogTitle>
                    <DialogContent>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    onClick={() => {
                                        window.open(
                                            "https://api.whatsapp.com/send?phone=5531994754366&text=Oi%20tudo%20bem?%20Gostaria%20de%20saber%20como%20funciona%20o%20registrador%20de%20pedidos%20para%20contratar.",
                                            "_blank"
                                        )
                                        setContratar(false)
                                    }}
                                    style={{ backgroundColor: "#075E54", color: "white" }}
                                    fullWidth
                                    variant="contained"
                                >
                                    Contactar por Whatsapp
                                </Button>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    onClick={() => {
                                        setContratar(false)
                                    }}
                                    fullWidth
                                    style={{ marginTop: "1em" }}
                                >
                                    Não quero
                                </Button>
                            </Col>
                        </Row>
                    </DialogContent>
                </Dialog>

                {tabStatus === "VIEW" ? (
                    <Row style={{ width: "100%", margin: "0" }}>
                        <AlertFixo
                            severity="warning"
                            style={{ width: "100%", marginBottom: "1em" }}
                        >
                            Você está conectado em <b>modo visualização</b> (não é possivel aceitar
                            pedidos)
                            <Button
                                color="default"
                                // style={{"background": "#28a745", "color":"white"}}
                                onClick={() => {
                                    setTabStatus("CRUD")
                                    window.name = ""
                                }}
                            >
                                Conectar Modo Aceitar Pedidos
                            </Button>
                        </AlertFixo>
                    </Row>
                ) : null}

                <Row style={{ flexDirection: "row", paddingInline: "15px", gap: "1rem" }}>
                    <TextField
                        style={{ background: "#fff", flex: "1 1 12rem" }}
                        id="procurar-pedido-alternativo"
                        onChange={e => buscarPedidos(e.target.value)}
                        label="Procurar"
                        variant="outlined"
                        size="small"
                    />
                    <FiltroEntregaRetirada />

                    {params.PUBLIC_HABILITAR_AGENDAMENTO && (
                        <FormControl variant="outlined" style={{ minWidth: "130px" }}>
                            <InputLabel>Agendados</InputLabel>
                            <Select
                                defaultValue={0}
                                value={filtroAgendado?.target?.value}
                                onChange={e => setFiltroAgendado(e)}
                                variant="outlined"
                                style={{ maxHeight: "40px" }}
                                label="agendado"
                            >
                                <MenuItem value={0}>Todos</MenuItem>
                                <MenuItem value={1}>Não agendados</MenuItem>
                                <MenuItem value={2}>Agendados</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                    <BotoesUtilitarios
                        estabelecimentos={estabelecimentos}
                        expandListaIntegracoes={expandListaIntegracoes}
                        setExpandListaIntegracoes={setExpandListaIntegracoes}
                        resumoDoDia={resumoDoDia}
                        handleBuscarDadosEstabelecimentos={handleBuscarDadosEstabelecimentos}
                        setModalConfiguracoes={setModalConfiguracoes}
                        setRegistradorModal={setRegistradorModal}
                        setMesaModal={setMesaModal}
                        atualizar={atualizar}
                    />
                </Row>
                <Row>
                    {recebedor.prepararPedidoAutomatico != true ? (
                        <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                            <Lista
                                tipoPainelImpressao={tipoPainelImpressao}
                                indexLista={1}
                                solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                                buscarStatus={buscarStatus}
                                loading={loadingPedidos}
                                seletorLista={
                                    recebedor.aceitarPedidoAutomatico
                                        ? "pedidosAceitos"
                                        : "pedidosAguardandoAceitacao"
                                }
                                classes={classes}
                                autorizacao={autorizacao}
                                impressorasQZ={impressorasQZ}
                                setModalInformacoesPedido={setModalInformacoesPedido}
                                mudarStatusPara={mudarStatusPara}
                                imprimirNotaFiscal={imprimirNotaFiscal}
                                alertStart={alertStart}
                                estabelecimentosRede={estabelecimentosRede}
                                filtroAgendado={filtroAgendado}
                            />
                        </Col>
                    ) : null}

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={2}
                            loading={loadingPedidos}
                            // TODO: Corrigir pedidos sumindo quando troca aceitarautomatico
                            seletorLista={
                                recebedor.aceitarPedidoAutomatico
                                    ? "pedidosEmPreparacao"
                                    : "pedidosAceitosMaisPreparacao"
                            }
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            mudarStatusPara={mudarStatusPara}
                            imprimirNotaFiscal={imprimirNotaFiscal}
                            alertStart={alertStart}
                            estabelecimentosRede={estabelecimentosRede}
                            filtroAgendado={filtroAgendado}
                        />
                    </Col>

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={3}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            loading={loadingPedidos}
                            seletorLista={"pedidosEmEntrega"}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            mudarStatusPara={mudarStatusPara}
                            imprimirNotaFiscal={imprimirNotaFiscal}
                            alertStart={alertStart}
                            estabelecimentosRede={estabelecimentosRede}
                            filtroAgendado={filtroAgendado}
                        />
                    </Col>

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={4}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            loading={loadingPedidos}
                            seletorLista={"pedidosFinalizados"}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            mudarStatusPara={mudarStatusPara}
                            imprimirNotaFiscal={imprimirNotaFiscal}
                            alertStart={alertStart}
                            estabelecimentosRede={estabelecimentosRede}
                            filtroAgendado={filtroAgendado}
                        />
                    </Col>

                    <DialogCancelamento
                        listaMotivoCancelamento={listaMotivoCancelamento}
                        confirmarCancelamento={confirmarCancelamento}
                        setConfirmarCancelamento={setConfirmarCancelamento}
                        removerPedidoListaAnterior={removerPedidoListaAnterior}
                        alertStart={alertStart}
                        setLoading={setLoading}
                    />

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalIfoodConfig}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalIfoodConfig(false)
                        }}
                    >
                        <DialogTitle>{"Dados iFood"}</DialogTitle>
                        <DialogContent>
                            <Col
                                xs={12}
                                md={12}
                                lg={12}
                                style={{ marginBottom: "1em", textAlign: "center" }}
                            >
                                <Typography>
                                    {statusLojaIfood?.title
                                        ? statusLojaIfood?.title
                                        : "--- Sem informações ---"}
                                </Typography>

                                <Typography>{statusLojaIfood?.message}</Typography>
                            </Col>

                            {statusLojaIfood?.extraInfo?.map((info, index) => (
                                <Col
                                    key={index}
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    style={{ marginBottom: "1em", textAlign: "center" }}
                                >
                                    <Typography>{info ? " * " + info : "---"}</Typography>
                                </Col>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setModalIfoodConfig(false)
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalConfiguracoes}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalConfiguracoes(false)
                        }}
                    >
                        <DialogTitle>{"Configurações"}</DialogTitle>

                        <DialogContent>
                            <Row>
                                <Col xs={12} style={{ margin: "0.5em 0", textAlign: "center" }}>
                                    {/* <img src={RECEBEDOR_ICON} style={{"width": '70px', "height": '70px'}}/> */}
                                    <img
                                        src={
                                            configuracoes.user?.parametros.estabelecimento?.urlLogo
                                                ? configuracoes.user?.parametros.estabelecimento
                                                      ?.urlLogo
                                                : aplicativoDados.urlLogo
                                        }
                                        style={{ width: "70px", height: "70px" }}
                                        alt=""
                                    />
                                </Col>

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        id="att-automatico-todos-pedidos"
                                        defaultValue={recebedor.buscarAutomaticamenteXSegundos}
                                        onChange={e => {
                                            if (
                                                e.target.value >= TEMPO_MINIMO_ALLDAY ||
                                                e.target.value <= 0
                                            ) {
                                                var valor = e.target.value
                                                if (valor <= 0) {
                                                    valor = 180
                                                    alertStart(
                                                        `Atualização automatica configurada a cada ${180} segundos!`,
                                                        "success"
                                                    )
                                                } else {
                                                    alertStart(
                                                        `Atualização automatica configurada a cada ${valor} segundos!`,
                                                        "success"
                                                    )
                                                }
                                                const tmp = JSON.parse(
                                                    JSON.stringify(configuracoes)
                                                )
                                                tmp.recebedor.buscarAutomaticamenteXSegundos = valor
                                                atualizarConfiguracoes({
                                                    recebedor: {
                                                        buscarAutomaticamenteXSegundos: valor,
                                                    },
                                                })
                                            } else {
                                                alertStart(
                                                    `Para atualizar automatico necessário tempo acima de ${TEMPO_MINIMO_ALLDAY} segundos!`,
                                                    "error"
                                                )
                                            }
                                        }}
                                        fullWidth
                                        placeholder={"120"}
                                        label="Atualizar em Segundos"
                                        variant="outlined"
                                    />
                                </Col>

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        id="exibicao-pedidos-maximo"
                                        defaultValue={recebedor.exibicaoMaxima}
                                        onChange={e => {
                                            if (e.target.value >= 10) {
                                                var valor = e.target.value
                                                // const tmp = JSON.parse(
                                                //     JSON.stringify(configuracoes)
                                                // )
                                                // tmp.recebedor.exibicaoMaxima = valor
                                                atualizarConfiguracoes({
                                                    recebedor: { exibicaoMaxima: valor },
                                                })
                                            } else {
                                                alertStart(
                                                    `A exibição mínima é de 10 pedidos`,
                                                    "error"
                                                )
                                            }
                                        }}
                                        fullWidth
                                        placeholder={"30"}
                                        label="Exibicação Máxima de Pedidos"
                                        variant="outlined"
                                    />
                                </Col>

                                <Col
                                    xs={12}
                                    md={6}
                                    lg={6}
                                    style={{ margin: "0.5em 0", display: "flex", gap: "0.25rem" }}
                                >
                                    <div style={{ flex: 1 }}>
                                        <TextField
                                            disabled
                                            defaultValue={parametros.viasImpressao}
                                            fullWidth
                                            label="Quant. de Vias"
                                            variant="outlined"
                                        />
                                    </div>
                                    {tipoPainelImpressao === "navegador" ? (
                                        <div style={{ flex: 1 }}>
                                            <FormControl
                                                variant="outlined"
                                                className={classes.formControl}
                                                fullWidth
                                            >
                                                <InputLabel>Tamanho Impr.</InputLabel>
                                                <Select
                                                    fullWidth
                                                    variant="outlined"
                                                    value={
                                                        configuracoes.printer.tamanhoFonteNavegador
                                                    }
                                                    defaultValue={"normal"}
                                                    onChange={e =>
                                                        atualizarConfiguracoes({
                                                            printer: {
                                                                tamanhoFonteNavegador:
                                                                    e.target.value,
                                                            },
                                                        })
                                                    }
                                                    label="Tamanho Impr."
                                                >
                                                    <MenuItem value="normal">Normal</MenuItem>
                                                    <MenuItem value="grande">Grande</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    ) : null}
                                </Col>

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <>
                                        <FormControl
                                            variant="outlined"
                                            className={classes.formControl}
                                            style={{ width: "100%" }}
                                        >
                                            <InputLabel id="tipopainel">
                                                Painel com Impressão
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                value={tipoPainelImpressao}
                                                disabled
                                                label="Painel com Impressão"
                                            >
                                                <MenuItem value="navegador">
                                                    Navegador Nativo
                                                </MenuItem>
                                                <MenuItem value={"plugin"}>Plugin QZ</MenuItem>
                                                <MenuItem value={"software"}>Software EXE</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </>
                                </Col>

                                {exibirSeletorTamanho ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                        <>
                                            <FormControl
                                                variant="outlined"
                                                className={classes.formControl}
                                                style={{ width: "100%" }}
                                            >
                                                <InputLabel id="impressoras">
                                                    Tamanho da Fonte
                                                </InputLabel>
                                                <Select
                                                    fullWidth
                                                    value={tamanhoFonteSelect}
                                                    onChange={e =>
                                                        atualizarConfiguracoes({
                                                            printer: {
                                                                tamanhoFonteSelect: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    label="Tamanho da Fonte"
                                                >
                                                    <MenuItem value="pequena">
                                                        <em>Pequena</em>
                                                    </MenuItem>

                                                    <MenuItem value="media">
                                                        <em>Media</em>
                                                    </MenuItem>

                                                    <MenuItem value="grande">
                                                        <em>Grande</em>
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </>
                                    </Col>
                                ) : null}

                                {tipoPainelImpressao === "plugin" &&
                                    tipoPainelImpressao !== "software" &&
                                    exibirTamanhoFonte && (
                                        <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                            <TextField
                                                id="tamanho-font"
                                                value={printer.tamanhoFonteImpressao}
                                                onChange={e =>
                                                    atualizarConfiguracoes({
                                                        printer: {
                                                            tamanhoFonteImpressao: e.target.value,
                                                        },
                                                    })
                                                }
                                                fullWidth
                                                placeholder={"14"}
                                                type={"number"}
                                                label="Tamanho Fonte Impressão"
                                                variant="outlined"
                                            />
                                        </Col>
                                    )}

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    {!mobile &&
                                    tabStatus === "CRUD" &&
                                    tipoPainelImpressao === "plugin" ? (
                                        <>
                                            <FormControl
                                                variant="outlined"
                                                className={classes.formControl}
                                                style={{ width: "100%" }}
                                            >
                                                <InputLabel id="impressoras">
                                                    Tipo Printer Cliente Fiel
                                                </InputLabel>
                                                <Select
                                                    fullWidth
                                                    labelId="tipoImpressao"
                                                    id="tipoImpressao"
                                                    value={tipoPrinter}
                                                    // value={}
                                                    onChange={e =>
                                                        atualizarConfiguracoes({
                                                            printer: {
                                                                tipoImpressao: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    label="Tipo Printer Cliente Fiel"
                                                >
                                                    <MenuItem value="code">
                                                        <em>Tipo CODE</em>
                                                    </MenuItem>

                                                    <MenuItem value="html">
                                                        <em>Tipo HTML</em>
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </>
                                    ) : null}
                                </Col>

                                <ListaImpressorasSelecionadas
                                    mobile={mobile}
                                    tipoPainelImpressao={tipoPainelImpressao}
                                    impressorasQZ={impressorasQZ}
                                    modalConfiguracoes={modalConfiguracoes}
                                />

                                {tipoPainelImpressao === "navegador" ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.2em 0 1em 0" }}>
                                        <Button
                                            onClick={e => {
                                                window.open(
                                                    "https://ajuda.clientefiel.app/painel-cliente-fiel/ferramentas/formas-de-impressao",
                                                    "_blank"
                                                )
                                            }}
                                            variant="contained"
                                            style={{ backgroundColor: "#6c757d", color: "white" }}
                                        >
                                            Imprimir Comanda Automaticamente
                                        </Button>
                                    </Col>
                                ) : null}

                                {!mobile && tabStatus === "CRUD" ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    defaultChecked={
                                                        recebedor.aceitarPedidoAutomatico
                                                    }
                                                    onChange={e => {
                                                        if (e.target.checked)
                                                            atualizarConfiguracoes({
                                                                recebedor: {
                                                                    aceitarPedidoAutomatico:
                                                                        e.target.checked,
                                                                },
                                                            })
                                                        else
                                                            atualizarConfiguracoes({
                                                                recebedor: {
                                                                    aceitarPedidoAutomatico:
                                                                        e.target.checked,
                                                                    prepararPedidoAutomatico:
                                                                        e.target.checked,
                                                                },
                                                            })

                                                        if (e.target.checked) {
                                                            pedidosAguardandoAceitacao.forEach(
                                                                pedido => {
                                                                    if (pedido.status === 0)
                                                                        aceitarPedido(pedido)
                                                                }
                                                            )
                                                        }
                                                    }}
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon fontSize="small" />
                                                    }
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="aceite-automatico"
                                                />
                                            }
                                            label="Aceitar Automaticamente os Pedidos"
                                        />
                                    </Col>
                                ) : null}

                                {!mobile &&
                                    tabStatus === "CRUD" &&
                                    recebedor.aceitarPedidoAutomatico && (
                                        <>
                                            <Col xs={12} md={12} lg={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            // disabled
                                                            defaultChecked={
                                                                recebedor.prepararPedidoAutomatico
                                                            }
                                                            onChange={e =>
                                                                atualizarConfiguracoes({
                                                                    recebedor: {
                                                                        prepararPedidoAutomatico:
                                                                            e.target.checked,
                                                                    },
                                                                })
                                                            }
                                                            icon={
                                                                <CheckBoxOutlineBlankIcon fontSize="small" />
                                                            }
                                                            checkedIcon={
                                                                <CheckBoxIcon fontSize="small" />
                                                            }
                                                            name="preparar-automatico"
                                                        />
                                                    }
                                                    label="Preparar Automaticamente os Pedidos"
                                                />
                                            </Col>
                                            <Col xs={12} md={12} lg={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            defaultChecked={imprimirPedidoMesa}
                                                            onChange={e =>
                                                                atualizarConfiguracoes({
                                                                    recebedor: {
                                                                        prepararPedidoAutomatico:
                                                                            e.target.checked,
                                                                        imprimirPedidoMesa:
                                                                            !configuracoes.recebedor
                                                                                .imprimirPedidoMesa,
                                                                    },
                                                                })
                                                            }
                                                            icon={
                                                                <CheckBoxOutlineBlankIcon fontSize="small" />
                                                            }
                                                            checkedIcon={
                                                                <CheckBoxIcon fontSize="small" />
                                                            }
                                                        />
                                                    }
                                                    label="Imprimir Pedido de Mesa"
                                                />
                                            </Col>
                                            {tipoPainelImpressao === "navegador" && (
                                                <Col xs={12} md={12} lg={12}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                defaultChecked={
                                                                    recebedor.imprimirPedidoAutomatico
                                                                }
                                                                onChange={e =>
                                                                    atualizarConfiguracoes({
                                                                        recebedor: {
                                                                            imprimirPedidoAutomatico:
                                                                                e.target.checked,
                                                                        },
                                                                    })
                                                                }
                                                                icon={
                                                                    <CheckBoxOutlineBlankIcon fontSize="small" />
                                                                }
                                                                checkedIcon={
                                                                    <CheckBoxIcon fontSize="small" />
                                                                }
                                                                name="imprimir-automatico"
                                                            />
                                                        }
                                                        label="Imprimir Automaticamente os Pedidos"
                                                    />
                                                </Col>
                                            )}
                                        </>
                                    )}

                                <Col xs={12} md={12} lg={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                defaultChecked={recebedor.exibirTempoEspera}
                                                onChange={e =>
                                                    atualizarConfiguracoes({
                                                        recebedor: {
                                                            exibirTempoEspera: e.target.checked,
                                                        },
                                                    })
                                                }
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                name="tempo-de-espera"
                                            />
                                        }
                                        label="Exibir tempo de espera"
                                    />
                                </Col>

                                <Col xs={12} md={12} lg={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={recebedor.efeitoSonoro}
                                                onChange={e => {
                                                    atualizarConfiguracoes({
                                                        recebedor: {
                                                            efeitoSonoro: e.target.checked,
                                                        },
                                                    })

                                                    window.setCookie(
                                                        "efeito-sonoro-ativo",
                                                        e.target.checked,
                                                        9999
                                                    )
                                                }}
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                name="efeito-sonoro"
                                            />
                                        }
                                        label="Efeito Sonoro"
                                    />
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        value={recebedor.duracaoEfeitoSonoro}
                                        label="Duração"
                                        disabled={!recebedor.efeitoSonoro}
                                        style={{ maxWidth: "5.5rem" }}
                                        onChange={e =>
                                            atualizarConfiguracoes({
                                                recebedor: {
                                                    duracaoEfeitoSonoro: e.target.value.replace(
                                                        /\D/g,
                                                        ""
                                                    ),
                                                },
                                            })
                                        }
                                    />
                                </Col>

                                <Col xs={12} md={12} lg={6}>
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        value={recebedor.limitePedidosFinalizados}
                                        label="Limite Pedidos Finalizados"
                                        helperText="0 para não haver limite"
                                        onChange={e => {
                                            const numberLimite = Number(
                                                e.target.value.replace(/\D/g, "")
                                            )

                                            if (!isNaN(numberLimite)) {
                                                recebedor.limitePedidosFinalizados = numberLimite

                                                atualizarConfiguracoes({
                                                    recebedor: {
                                                        limitePedidosFinalizados: numberLimite,
                                                    },
                                                })
                                            }
                                        }}
                                    />
                                </Col>

                                {exibirImprimirLogo ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    defaultChecked={printer.imprimirLogo}
                                                    onChange={e =>
                                                        atualizarConfiguracoes({
                                                            printer: {
                                                                imprimirLogo: e.target.checked,
                                                            },
                                                        })
                                                    }
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon fontSize="small" />
                                                    }
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="imprimir-logo"
                                                />
                                            }
                                            label="Imprimir logo"
                                        />
                                    </Col>
                                ) : null}

                                {exibir99food && (
                                    <Col xs={12} md={6} lg={6}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    defaultChecked={printer.imprimir99automatico}
                                                    onChange={e => {
                                                        atualizarConfiguracoes({
                                                            printer: {
                                                                imprimir99automatico:
                                                                    e.target.checked,
                                                            },
                                                        })

                                                        window.setCookie(
                                                            "imprimir-99",
                                                            e.target.checked,
                                                            9999
                                                        )
                                                    }}
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon fontSize="small" />
                                                    }
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="imprimir99automatico"
                                                />
                                            }
                                            label="Imprimir comandas da 99food"
                                        />
                                    </Col>
                                )}

                                <Col xs={12} md={6} lg={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                defaultChecked={recebedor.mostrarEndereco}
                                                onChange={e =>
                                                    atualizarConfiguracoes({
                                                        recebedor: {
                                                            mostrarEndereco: e.target.checked,
                                                        },
                                                    })
                                                }
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                name="mostrar-endereco"
                                            />
                                        }
                                        label="Mostrar Endereço"
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                defaultChecked={recebedor.mostrarEntregador}
                                                onChange={e =>
                                                    atualizarConfiguracoes({
                                                        recebedor: {
                                                            mostrarEntregador: e.target.checked,
                                                        },
                                                    })
                                                }
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                name="mostrar-entregador"
                                            />
                                        }
                                        label="Mostrar Entregador"
                                    />
                                </Col>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setModalConfiguracoes(false)
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={openEstabelecimentos}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleCloseEstabelecimentos}
                    >
                        <DialogTitle>{"Configurações dos Estabelecimentos"}</DialogTitle>
                        <DialogContent>
                            {estabelecimentos.map((estabelecimento, index) => (
                                <Row key={index}>
                                    <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        style={{ marginBottom: "1em", textAlign: "center" }}
                                    >
                                        <Typography>{estabelecimento.nome}</Typography>
                                    </Col>
                                    <Col xs={12} md={6} lg={6} style={{ marginBottom: "1em" }}>
                                        <FormControl
                                            variant="outlined"
                                            className={classes.formControl}
                                            fullWidth
                                        >
                                            <InputLabel htmlFor="outlined-age-native-simple">
                                                Status
                                            </InputLabel>
                                            <Select
                                                native
                                                value={
                                                    estabelecimento.situacao === 1 &&
                                                    estabelecimento.pausado
                                                        ? 2
                                                        : estabelecimento.situacao
                                                }
                                                fullWidth
                                                label="Status"
                                                style={{ padding: 0 }}
                                                onChange={e => {
                                                    atualizarStatusEstabelecimento(
                                                        e,
                                                        estabelecimento,
                                                        index
                                                    )
                                                }}
                                                endAdornment={
                                                    <InputAdornment
                                                        style={{
                                                            position: "absolute",
                                                            left: "15px",
                                                        }}
                                                    >
                                                        {estabelecimento.situacao === 1 &&
                                                        estabelecimento.pausado ? (
                                                            <PauseCircleFilledIcon
                                                                style={{ color: "#ffc107" }}
                                                            />
                                                        ) : estabelecimento.situacao === 0 ? (
                                                            <CancelIcon
                                                                style={{ color: "#dc3545" }}
                                                            />
                                                        ) : (
                                                            <PlayCircleFilledIcon
                                                                style={{ color: "#28a745" }}
                                                            />
                                                        )}
                                                    </InputAdornment>
                                                }
                                                inputProps={{
                                                    name: "Status",
                                                    id: "select-status-estabelecimento",
                                                }}
                                            >
                                                <option value={1}>Aberto</option>
                                                <option value={0}>Fechado</option>
                                                <option value={2}>Pausado</option>
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col xs={12} md={6} lg={6}>
                                        <TextField
                                            className="tempoEntrega"
                                            variant="outlined"
                                            placeholder="Tempo de entrega"
                                            helperText="Exemplo: 45-60 min"
                                            defaultValue={estabelecimento.tempoEntregaTexto}
                                            inputProps={{
                                                "data-index-estabelecimento": index,
                                            }}
                                        />
                                    </Col>
                                    <Divider className={"divisaoEstabelecimentos"}></Divider>
                                </Row>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseEstabelecimentos}>Voltar</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openConfirmacaoPedidosRepetidosFui}
                        onClose={() => setOpenConfirmacaoPedidosRepetidosFui(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Informativo"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {messageOpenConfirmacaoPedidosRepetidosFui}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setOpenConfirmacaoPedidosRepetidosFui(false)}
                                color="default"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    calcularValorEntregaFuiApp()
                                    setOpenConfirmacaoPedidosRepetidosFui(false)
                                }}
                                color="primary"
                                autoFocus
                            >
                                Consultar mesmo assim
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalEntregadorFuiDelivery?.openModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setPedidosEntregaFuiApp([])
                            setModalEntregadorFuiDelivery({
                                ...modalEntregadorFuiDelivery,
                                openModal: false,
                                pedidoSelecionado: null,
                            })
                        }}
                    >
                        <DialogTitle>{"Fui App Delivery"}</DialogTitle>
                        <DialogContent>
                            <Row>
                                <>
                                    <Col xs={12} md={12} lg={12}>
                                        <Typography variant="body2" component="p">
                                            Agrupar com outros pedidos
                                        </Typography>

                                        {showCheckbox(
                                            modalEntregadorFuiDelivery?.pedidoSelecionado
                                        )}
                                    </Col>
                                </>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    validarPedidosJaEnviadosFuiDelivery()
                                }}
                            >
                                Calcular Valor
                            </Button>
                            <Button
                                onClick={() => {
                                    setPedidosEntregaFuiApp([])
                                    setModalEntregadorFuiDelivery({
                                        ...modalEntregadorFuiDelivery,
                                        openModal: false,
                                        pedidoSelecionado: null,
                                    })
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {showDialogConfirmarValoresFui()}

                    <DialogInformacoesPedido mudarStatusPara={mudarStatusPara} />
                </Row>
                <ListaIntegracoes
                    expandListaIntegracoes={expandListaIntegracoes}
                    setExpandListaIntegracoes={setExpandListaIntegracoes}
                    statusLojaIfood={statusLojaIfood}
                    statusLoja99={statusLoja99}
                    estabelecimentos={estabelecimentos}
                />
                <DialogAlertas
                    alertas={alertas}
                    abrirAlertas={abrirAlertas}
                    setAbrirAlertas={setAbrirAlertas}
                />
            </Container>
        </RecebedorContextProvider>
    )
}
